// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content[data-v-b0b4e484]{width:1260px;padding:50px 30px 0px 30px;overflow:visible}.content .title[data-v-b0b4e484]{font-size:25px;color:#333}.content .imgs[data-v-b0b4e484]{margin-top:50px;display:flex;flex-wrap:wrap}.content .imgs .img[data-v-b0b4e484]{width:400px;height:264px;cursor:pointer;transition:all .3s;background-position:center}.content .imgs .img[data-v-b0b4e484]:hover{transform:scale(1.1);z-index:99}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
